import { render, staticRenderFns } from "./commodityDetails.vue?vue&type=template&id=6c415063&"
import script from "./commodityDetails.vue?vue&type=script&lang=ts&"
export * from "./commodityDetails.vue?vue&type=script&lang=ts&"
import style0 from "./commodityDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports